import type { MutableRefObject, Ref } from "react";
import { useEffect, useState } from "react";
import {
  RegexValidator,
  RegexValidatorResponse,
} from "../../models/regex/RegexValidator";
import { useAsync } from "../hooks/useAsync";

export { RegexInput };
type Props = {
  initialValue: string;
  disabled?: boolean;
  placeholder?: string;
  updated: (result: RegexValidatorResponse) => void;
  parentRef?: MutableRefObject<HTMLElement | null>;
  onFocus?: () => void;
  onBlur?: () => void;
};
const RegexInput = ({
  ref,
  ...props
}: Props & {
  ref?: Ref<HTMLInputElement>;
}) => {
  // const inputRef = useRef<HTMLInputElement | null>(null);
  const [value, setValue] = useState<string>(props.initialValue);

  const [result, trigger, loading] = useAsync<RegexValidatorResponse | null>(
    () => RegexValidator.validate(value),
    null,
  );

  useEffect(() => {
    if (result == null) {
      return;
    }
    if (result.valid && result.regex === props.initialValue) {
      return;
    }
    result.regex = value;
    props.updated(result);
  }, [result]);

  useEffect(() => {
    if (value !== props.initialValue) {
      setValue(props.initialValue);
    }
  }, [props.initialValue]);

  return (
    <>
      <input //{...triggerProps}
        ref={ref}
        type={"text"}
        className={"monospace"}
        disabled={props.disabled || loading}
        placeholder={props.placeholder}
        value={value}
        onChange={(e) => {
          const newValue = e.target.value;
          setValue(newValue);
          if (newValue === "") {
            props.updated(
              new RegexValidatorResponse({
                extractedField: "",
                valid: true,
                reason: "",
              }),
            );
          }
        }}
        onFocus={props.onFocus}
        onBlur={() => {
          if (value !== props.initialValue) {
            trigger();
          }
          if (props.onBlur) {
            props.onBlur();
          }
        }}
      />
    </>
  );
};
